module.exports = __webpack_public_path__ + "img/giftCard_sharePic.72828c55.jpg";